require("../sass/style.scss");
require("../fonts/fontello/css/fontello.css");

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/tab.js");
require("./vendor/slick.min.js");
require("./custom/preloader.es6");
require("./custom/wp_nav.es6");
require("./custom/anchoirs.es6");

(function ($) {
    if ($(".section-downloads").length > 0) {
        require("./vendor/jquery.overlayScrollbars.min.js");
        require("./custom/section_downloads.es6");
    }

    if ($(".section-information-box").length > 0) {
        require("./custom/section_information_box.es6");
    }

    if ($(".section-text-with-image").length > 0) {
        require("./custom/section_text_with_image.es6");
    }

    if ($(".section-text-column-with-stats").length > 0) {
        require("./custom/section_text_column_with_stats.es6");
    }

    if ($(".section-home-hero").length > 0) {
        require("./custom/section_home_hero.es6");
    }

})(jQuery);